import { Suspense } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Ranking from './components/Ranking';
import Contact from './components/Contact';
import Cards from './components/Cards';
import Updates from './components/Updates';
import Carousel from './components/Carousel';
import About from './components/About';
import Media from './components/Media';
import Comments from './components/Comments';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import Topics from './components/Topics';
import Faq from './components/Faq';
import Footer from './components/Footer';

function SectionFallback() {
  return (
    <div className="w-full py-20 flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />

        <Suspense fallback={<SectionFallback />}>
          <Features />
          <Ranking />
          <Contact />
          <Cards />
          <Updates />
          <Carousel />
          <About />
          <Media />
          <Comments />
          <IndexSection />
          <AppSection />
          <Topics />
          <Faq />
        </Suspense>
      </main>
      <Footer />
    </>
  );
}